import React, { Component } from 'react';
import './gallery.css';
import galleryJSON from '../gallery.json';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ShareOptions from './share.component';
import Comments from './comments.component';

class Gallery extends Component {

    state = {
        selected: null,
        modal: false,
        modalScrolled: false
    }

    constructor(props) {
        super(props)

        this.scrollToComments = this.scrollToComments.bind(this);
    }

    componentDidMount() {
        window.addEventListener('keyup', ev => {
            if (ev.key === "Escape") {
                this.setState({
                    modal: false
                })
            }
        })
    }

    renderModal = (img) => {
        return <div className="modal" ref="modal">
            <button className="close" onClick={() => {
                this.setState({
                    modal: false
                })
            }}
            >CLOSE</button>
            <div className="modal-image" style={{height: window.innerHeight}}>
                <LazyLoadImage src={`gallery/${img}`} height="220px" effect="opacity" placeholderSrc={`placeholders/${img}`} delayTime="1000" threshold="200" />
            </div>
            <div className="modal-content">
                <div className="modal-content-bar">
                    <ShareOptions className="modal-content-bar-share" url={`${window.location.origin}/gallery/${img}`} type='centered' />
                    <button className="modal-button-scroll" onClick={(ev) => { this.scrollToComments(ev) }}>التعليقات</button>
                </div>
                <div ref="comments">
                    <Comments id={btoa(`la7zat-${img}`)} />
                </div>
            </div>
        </div>
    }
    

    scrollToComments(ev) {
        this.refs.modal.scrollTop = this.refs.comments.offsetTop;
        console.log(this.refs.modal.scrollTop, this.refs.comments.offsetTop);
        this.setState({
            modalScrolled: true
        })
    }

    renderMartyerImages = (img, index) => {
        let url = `thumbnails/${img.name}`;
        let css = '';

        return <div className={`card ${css}`} key={index} onClick={() => {
            this.setState({
                selected: img.name,
                next: img.next,
                prev: img.prev,
                modal: true
            })
        }}>
            <LazyLoadImage src={url} height="220px" effect="opacity" placeholderSrc={`placeholders/${img.name}`} delayTime="1000" threshold="200" alt={index} />
        </div>
    }

    renderImages = (img, index) => {
        let url = `thumbnails/${img.name}`;
        let css = '';

        if (index % 16 === 0) {
            css = 'card--full-wdith';
            url = `gallery/${img.name}`;
        }

        return <div className={`card ${css}`} key={index} onClick={() => {
            this.setState({
                selected: img.name,
                next: img.next,
                prev: img.prev,
                modal: true,
                modalScrolled: false
            })
        }}>
            <LazyLoadImage src={url} height="220px" effect="opacity" placeholderSrc={`placeholders/${img.name}`} delayTime="1000" threshold="200" alt={index} />
        </div>
    }

    render() {
        return (
            <React-Fragment>
                <h2 className="heading">شهداءنا ماماتو عايشين مع الثوار المات ضمير خاين حالفين نجيب التار</h2>
                <section id="gallery">
                    {/* <LazyLoadImage className="banner" src={`https://www.alsoug.com//uploads/files/orig/15042019085446AM.png`} height="220px" effect="opacity" placeholderSrc={`placeholders/empty.jpg`} delayTime="1000" threshold="200"  /> */}
                    {galleryJSON.data.martyersObjects.map(this.renderMartyerImages)}
                    {galleryJSON.data.filesObjects.map(this.renderImages)}
                    {this.state.modal ? this.renderModal(this.state.selected) : null}
                </section>
            </React-Fragment>
        );
    }
}

export default Gallery;